// Utility functions for authentication token management

export const getAuthToken = () => {
  // Try to get token from userData first
  const userData = localStorage.getItem("userData");
  if (userData) {
    try {
      const { token } = JSON.parse(userData);
      if (token) {
        return token;
      }
    } catch (error) {
      console.error("Error parsing user data:", error);
    }
  }

  // Try to get token from Supabase session
  const supabaseSession = localStorage.getItem(
    "sb-bkhaviccwhpouwmuydef-auth-token"
  );
  if (supabaseSession) {
    try {
      const { access_token } = JSON.parse(supabaseSession);
      if (access_token) {
        return access_token;
      }
    } catch (error) {
      console.error("Error parsing Supabase session:", error);
    }
  }

  return null;
};

export const setAuthToken = (token) => {
  // Store token in userData
  const userData = localStorage.getItem("userData");
  if (userData) {
    try {
      const parsedData = JSON.parse(userData);
      parsedData.token = token;
      localStorage.setItem("userData", JSON.stringify(parsedData));
    } catch (error) {
      console.error("Error updating user data:", error);
    }
  }
};

export const clearAuthTokens = () => {
  localStorage.removeItem("userData");
  localStorage.removeItem("sb-bkhaviccwhpouwmuydef-auth-token");
  localStorage.removeItem("loggedin");
};

export const isAuthenticated = () => {
  return getAuthToken() !== null;
};
